import { render, staticRenderFns } from "./ComformDialog.vue?vue&type=template&id=f9f2a00e&scoped=true&"
import script from "./ComformDialog.vue?vue&type=script&lang=js&"
export * from "./ComformDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9f2a00e",
  null
  
)

export default component.exports